<div [ngClass]="showHeader?'pl-2':''">
  <h5 *ngIf="showHeader" class="textOrange">Dashboard Management</h5>
  <kendo-grid #dashboardMgmtGrid [kendoGridBinding]="gridData"
              [filterable]="true"
              [sortable]="true"
              kendoGridSelectBy="Id"
              (edit)="editDashboard($event)"
              (remove)="deleteDashboard($event)"
              (cancel)="cancelHandler($event)"
              (save)="saveDashboard($event)"
              [selectable]="selectableSettings"
              (selectedKeysChange)="selectedKeysChange($event)"
              [style]="'height: calc(100vh - '+gridHeightFactor+'px)'"
              [rowClass]="rowClass"
              [selectedKeys]="selectedKeys"
              [sort]="sort"
              [pageable]="true">
    <kendo-grid-checkbox-column width="40px"></kendo-grid-checkbox-column>
    <ng-template kendoGridToolbarTemplate>
      <button kendoGridExcelCommand icon="file-excel">Export to Excel</button>
    </ng-template>
    <kendo-grid-column field="TypeName" title="Type" width="120px">
      <ng-template kendoGridFilterCellTemplate>
        <kendo-multiselect [data]="stageMultiselectItems" textField="Name" valueField="Id" (valueChange)="stageFilterChanged($event)">
        </kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Title" title="Dashboard Name">
      <ng-template kendoGridEditTemplate let-formGroup="dashForm" let-dataItem="dataItem">
        <input type="text" class="k-textbox" [formControl]="dashForm.get('Title')" maxlength="100" />
        <div class="text-danger">{{dashForm.get('Title').errors?.message}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Description" title="Description">
      <ng-template kendoGridEditTemplate let-column="column" let-formGroup="dashForm" let-dataItem="dataItem">
        <textarea [formControl]="dashForm.get('Description')" class="k-textbox" style="height:100px"></textarea>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Shared" title="Public" width="88px" filter="boolean">
      <kendo-grid-messages filterIsTrue="Public"
                           filterIsFalse="Private">
      </kendo-grid-messages>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        <input type="checkbox" [checked]="dataItem.Shared" class="k-checkbox" disabled />
      </ng-template>
      <ng-template kendoGridEditTemplate let-column="column" let-formGroup="dashForm" let-dataItem="dataItem">
        <input type="checkbox" [ngClass]="canMakePublic?'':'cursorNotAllowed disabled'" [formControl]="dashForm.get('Shared')" class="k-checkbox" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="spare" title="Owner" width="190px"></kendo-grid-column>
    <kendo-grid-column field="Folder.Title" title="Folder" width="140px"></kendo-grid-column>
    <kendo-grid-command-column width="100px">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        <div *ngIf="!dataItem.Folder?.Locked">
          <button kendoGridEditCommand icon="edit" class="textOrange" *ngIf="dataItem.UserCanEditOrDelete"></button>
          <button kendoGridRemoveCommand icon="delete" class="text-danger" *ngIf="dataItem.UserCanEditOrDelete"></button>
          <button kendoGridSaveCommand icon="check" class="text-success" [disabled]="dashForm?.invalid"></button>
          <button kendoGridCancelCommand icon="cancel" class="text-danger"></button>
        </div>
        <span class="btn k-icon k-i-lock" *ngIf="dataItem.Folder?.Locked"></span>
      </ng-template>
    </kendo-grid-command-column>
    <kendo-grid-excel fileName="Dashboards.xlsx"></kendo-grid-excel>
    <ng-template kendoPagerTemplate let-total="total">      
        <span [style.visibility]="selectedKeys.length>0 ? 'visible': 'hidden'" class="w-50 text-left">{{selectedKeys.length}} Selected</span>
        <span class="d-block w-50 text-right">{{total}} Dashboards</span>
    </ng-template>
  </kendo-grid>
  <button (click)="multiDeleteConfirm()" kendoButton [primary]="true" [disabled]="selectedKeys.length<1" [ngClass]="{'cursorNotAllowed disabled' : selectedKeys.length<1}" class="mt-3 float-left"><span>Delete Dashboard<span *ngIf="selectedKeys.length>1">s</span></span></button>
</div>
